(function() { module.exports = window["AFFWP"]["portal"]["storage"]; }());